import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { firstValueFrom } from 'rxjs';

import { LoginService } from '../../services/login.service';
import { simpleTransitions } from '../../shared/animations/simple-transitions';
import { UserService } from '../../services/user.service';

import { ValidateUserErrorDialogComponent } from './dialogs/validate-user-error.component';
import { PrivacySettingComponent } from './privacy-setting.component';
import { ForgotPasswordDialogComponent } from './forgot-info.component';


@Component({
	selector: 'copo-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.css'],
	animations: simpleTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	standalone: true,
	imports: [
		NgIf,
		ReactiveFormsModule,
		MatIconModule,
		NgSwitch,
		TranslateModule,
		NgSwitchCase,
		NgSwitchDefault,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyButtonModule,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyFormFieldModule,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyInputModule
	]
})

export class ResetPasswordComponent {
	@HostBinding('class.mat-typography') matTypography = true;
	@HostBinding('class.full-height') fullHeight = true;
	sessionLoaded = false;
	infoStatus: string | undefined;
	emailPattern = '^[a-zA-Z0-9._\'-]+@[a-zA-Z0-9.-]{2,}[.][a-zA-Z]{2,}$';
	submitting = false;
	passwordFormGroup = new FormGroup({
		userEmail: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
	});

	constructor(
		private readonly loginService: LoginService,
		// eslint-disable-next-line deprecation/deprecation
		public dialog: MatDialog,
		private readonly userService: UserService
	) {}

	get year() {
		return new Date().getFullYear();
	}

	get forgotPasswordUrl() {
		return this.loginService.createUrl(
			'/rest/v1/email/forgotPassword'
		);
	}

	onForgotPasswordSubmit() {
		if (!this.passwordFormGroup.valid) {
			return;
		}
		const val = <Record<string, string>> this.passwordFormGroup.value;
		this.submitting = true;
		this.userService.resetPassword(val['userEmail'], 'true').then(() => {
			this.infoStatus = 'verify-password-legacy.lost-password-email-sent';
			this.openInfoDialog();
			this.submitting = false;
		}).catch(error => {
			if (error instanceof HttpErrorResponse) {
				this.dialog.open(ValidateUserErrorDialogComponent, {
					width: '550px',
					panelClass: 'validate-user-dialog',
					// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
					data: { errorStatus: (<{ message: string }>error.error.status) }
				});
			}
			this.submitting = false;
		});
	}

	openPrivacyPolicyDialog() {
		this.dialog.open(
			PrivacySettingComponent,
			{
				panelClass: 'privacy-modal',
				width: '1000px',
				maxHeight: '90vh',
				disableClose: true,
				autoFocus: false
			}
		);
	}

	openInfoDialog() {
		const dialogRef = this.dialog.open(ForgotPasswordDialogComponent, {
			width: '550px',
			panelClass: 'validate-user-dialog',
			data: { infoStatus: this.infoStatus }
		});
		firstValueFrom(dialogRef.afterClosed())
			.then(() => {
				location.replace(this.userService.accessUrl().toString());
			})
			.catch(error => {
				console.error('Error during go back dialog', error);
			});
	}
}
